import React from 'react';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 border-t border-gray-800 py-8" data-id="element-104">
      <div className="container mx-auto px-4" data-id="element-105">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-106">
          <div className="mb-4 md:mb-0" data-id="element-107">
            <h2 className="text-xl font-bold text-indigo-400" data-id="element-108">Sparrymation</h2>
            <p className="text-gray-400 text-sm mt-1" data-id="element-109">Søren Bro Sparre</p>
          </div>
          <div className="text-center md:text-right" data-id="element-110">
            <p className="text-gray-400 text-sm" data-id="element-111">
              &copy; {currentYear} Søren Bro Sparre. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};